<template>
  <div>
    <h3>Drawer</h3>
    <br>
    <div>
      <el-button :plain="true" @click="open">Open drawer</el-button>
    </div>
    <br>
      <el-drawer
      :before-close="handleBeforeClose"
      :visible.sync="dialogDrawer"
      @close="handleBeforeClose"
      direction="rtl"
      ref="refDrawer"
      v-loading="ui.loadingDrawerProvinceApply"
      >
      <div slot="title">
        <p class="title-3 color-neutral-900">
          Title
        </p>
      </div>
      <div>
        <div class="content">
          <p>What is Lorem Ipsum?
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
          <p>What is Lorem Ipsum?
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
          <p>What is Lorem Ipsum?
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
          <p>What is Lorem Ipsum?
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
        </div>
        <div class="footer">
          <div class="is-button">
            <el-button @click="dialogDrawer = false">Cancel</el-button>
            <el-button type="primary">Confirm</el-button>
          </div>
        </div>
      </div>

    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'Drawer',
  components : {
  },
  data() {
    return {
      dialogDrawer: false,
      ui: {
        loadSearchProvince: false
      },
      dataBank: {}

    }
  },
  methods: {
    async open () {
      this.dialogDrawer = true
    },

    handleBeforeClose () {
      this.dataBank = {}
      this.dialogDrawer = false
    }

  }
}
</script>

<style lang="scss" scoped>
:deep(.el-drawer__header) {
  padding: 40px 32px 24px 32px;
  margin-bottom: 0;
  display: flex;
}
:deep(.el-drawer__body) {
  height: calc(100vh - 196px);
  padding: 0 32px;;
}
:deep(.el-drawer) {
  width: 50% !important;
  @media (max-width: 1024px) {
    width: 50% !important;
  }
  @media (max-width: 540px) {
    width: 100% !important;
  }
}
.content {
  max-height: calc(100vh - 196px);
  overflow-y:  auto;
    &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    margin: 5px 0;
    background-color: #DCDFE6;
  }
  &::-webkit-scrollbar-thumb:hover {
    width: 8px;
    background: #999999;
  }
}
.footer {
  height: 100px;
  position: absolute;
  bottom: 0;
  width: 100%;
  .is-button {
    padding: 24px 64px 40px 32px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
